export default "__VITE_ASSET__3lUezK1D__"